import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import { getSliceContent } from './content';
import {
  createResponsiveSelector,
  resolveAlignmentSetting,
  resolvePositionSetting,
  resolveIsDarkSetting,
} from './settings';
import get from '../helpers/get';

export const getSliceAlignment = createResponsiveSelector(resolveAlignmentSetting);
export const getSlicePosition = createResponsiveSelector(resolvePositionSetting);
export const getSliceIsDark = createResponsiveSelector(resolveIsDarkSetting);

export const getSliceOverlayImage = createPerSliceIdSelector(
  getSliceContent,
  content => get(content, ['overlay_vector_image']),
);
